import { InfoButtonWithModal } from '@/components/common/InfoModal';
import { Paragraph } from '@/components/common/Typography';

const UnknownBalanceDateInfoButton = ({
    balanceDate,
}: {
    balanceDate: string;
}) => (
    <InfoButtonWithModal
        title="Why is my balance date unknown?"
        buttonProps={{
            onClickEventParams: {
                location: 'Balance Date Unknown',
            },
        }}
        color="gray"
    >
        <Paragraph>
            Some institutions don’t provide our partners with the date when the
            balance was last updated. The balance shown is the most recent
            balance our data provider could retrieve as of {balanceDate}.
        </Paragraph>
        <Paragraph>
            To provide account connectivity, we work with trusted partners like
            Finicity, Yodlee, MX, Plaid, and Akoya. These partners help us
            securely access your account balances and transactions.
        </Paragraph>
    </InfoButtonWithModal>
);

export default UnknownBalanceDateInfoButton;
